import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useParams } from 'react-router';
import { Switch, Route, useLocation, matchPath, useHistory } from 'react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';

// Hooks
import { useResponsiveScreenWidth } from 'Wpds/hooks/useResponsiveScreenWidth';
import { useMeetingBot } from 'Shared/utils/hooks/use-meeting-bot';

// Constants
import PageUrls from 'Shared/constants/PageUrls.constants';

// Util
import PageUrlUtils from 'Shared/utils/PageUrls.utils';

// Components
import { WpMenu, WpMenuItem } from 'Wpds/components/menu';
import CompletedSection from './partials/CompletedSection/CompletedSection';
import WorkspaceAgendaHistory from './WorkspaceAgendaHistory';

// Styles
import './WorkspaceHistoryTab.scss';
import WorkspaceHistoryMeetingSummaries from './partials/MeetingSummaries/WorkspaceHistoryMeetingSummaries';

const WorkspaceHistoryTab = () => {
  const { isLarge } = useResponsiveScreenWidth({ isAtMost: true });
  const { workspaceHistorySnapshotsUi: showAgendaHistory } = useFlags();
  const { pathname } = useLocation();
  const history = useHistory();
  const { workspaceId, itemUuid } = useParams();
  const { isMeetingBotEnabled } = useMeetingBot();

  useEffect(() => {
    if (matchPath(pathname, { path: PageUrls.WORKSPACE_HISTORY_PAGE, exact: true }))
      if (showAgendaHistory) history.push(PageUrlUtils.makeWorkspaceHistoryAgendaUrl(workspaceId));
      else history.push(PageUrlUtils.makeWorkspaceHistoryItemsUrl(workspaceId));
  }, [pathname, showAgendaHistory]);

  const baseClassName = 'WorkspaceHistoryTab';
  const classes = classnames(baseClassName, isLarge && `${baseClassName}--column`);

  return (
    <div className={classes}>
      {showAgendaHistory && (
        <div className={`${baseClassName}__menu-wrapper`}>
          <WpMenu direction={isLarge ? 'horizontal' : 'vertical'}>
            <WpMenuItem to={PageUrlUtils.makeWorkspaceHistoryAgendaUrl(workspaceId)}>Meetings Notes</WpMenuItem>
            <WpMenuItem to={PageUrlUtils.makeWorkspaceHistoryItemsUrl(workspaceId)}>Completed Items</WpMenuItem>
            {isMeetingBotEnabled && (
              <WpMenuItem to={PageUrlUtils.makeWorkspaceHistoryMeetingSummariesUrl(workspaceId)}>
                Meeting Summaries
              </WpMenuItem>
            )}
          </WpMenu>
        </div>
      )}
      <div className={`${baseClassName}__body`}>
        <Switch>
          <Route path={[PageUrls.WORKSPACE_HISTORY_MEETING_SUMMARIES]} component={WorkspaceHistoryMeetingSummaries} />
          <Route
            path={[PageUrls.WORKSPACE_AGENDA_HISTORY, PageUrls.WORKSPACE_AGENDA_HISTORY_ITEM_COMMENTS]}
            component={WorkspaceAgendaHistory}
          />
          <Route
            path={[PageUrls.WORKSPACE_HISTORY_PAGE_ITEMS, PageUrls.WORKSPACE_HISTORY_PAGE_ITEMS_ITEM_COMMENTS_PAGE]}
          >
            <CompletedSection focusedItemUuid={itemUuid} />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default WorkspaceHistoryTab;
